import React from 'react';

import { Text } from '@change/ds-core-ui/next';

import { usePetitionDetails } from '../../../../../../hooks/petitionDetails';
import { useSignaturesDistributionContext } from '../../shared/provider';

export function SignatureMapConfigurator(): React.JSX.Element | null {
	const { id } = usePetitionDetails();
	const {
		data: { zoomLevel, clusterSize },
		actions: { setZoomLevel, setClusterSize, setRerunNow },
	} = useSignaturesDistributionContext();

	const onZoomLevelChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setZoomLevel(parseFloat(event.target.value));
		setRerunNow(true);
	};

	const onClusterSizeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setClusterSize(parseFloat(event.target.value));
		setRerunNow(true);
	};

	if (!zoomLevel || !clusterSize) {
		return null;
	}
	return (
		<div className="my-8 overflow-scroll" data-qa="supporter-map-config-container">
			<Text as="h3" fontWeight="bold" size="x-small" variant="heading" data-qa="supporter-map-config-heading">
				Map Configuration (admin view only)
			</Text>
			<div className="flex flex-col">
				<label htmlFor="cluster-size-edit">Cluster size ({clusterSize})</label>
				<input
					id="cluster-size-edit"
					data-testid="cluster-size-edit"
					type="range"
					defaultValue={clusterSize}
					onChange={onClusterSizeChange}
					min="0.1"
					max="3"
					step="0.01"
				/>
			</div>
			<div className="flex flex-col">
				<label htmlFor="zoom-level-edit">Zoom Level ({zoomLevel})</label>
				<input
					id="zoom-level-edit"
					data-testid="zoom-level-edit"
					defaultValue={zoomLevel}
					onChange={onZoomLevelChange}
					type="range"
					name="zoom-level"
					min="1"
					max="15"
					step="0.2"
				/>
			</div>

			<pre data-qa="map-settings">{JSON.stringify({ petitionId: id, clusterSize, zoomLevel })}</pre>
		</div>
	);
}
